<template>
  <div class="col-span-6">
    <label for="field.label" class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <div class="rounded-md shadow-sm">
      <div class="flex">
        <div class="flex-grow mt-2">
          <input
            type="number"
            @input="$parent.updateValue(field.key, $event.target.value)"
            :value="formdata[field.key]"
            :min="this.field.min"
            :max="field.max"
            class="focus:ring-indigo-500 focus:border-indigo-500 block w-full 2xl:text-sm sm:text-xl border-gray-300 shadow-sm rounded-md"
          >
        </div>
      </div>
    </div>
    <p v-if="validation.msg !== ''" class="mt-2 2xl:text-sm sm:text-lg text-red-600" id="email-error">* {{validation.msg}}</p>
  </div>
</template>

<script>

export default {
  name: 'number-field',
  data() {
    return {
      dependentdata: [],
      value: 0,
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    validation: {
      type: Object,
      required: false,
      default() {
        return {'msg': ''}
      }
    }
  },
  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal) {
        console.log('formdata', newVal)
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
              this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
              await this.fetchInitialValue()
            }
          } else {
            if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
              this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
              await this.fetchInitialValue()
            }
          }
        }
      }
    },
    field: {
      deep: true,
      handler: function(newVal) {
        console.log('field', newVal)
        this.checkDepends()
      }
    },
  },
  methods: {
    checkDepends() {
      if (this.field.options.depends !== "" && this.field.options.depends !== undefined) {
        this.fetchInitialValue()
      }
    },
    async fetchInitialValue() {
      console.log('fetchOptions')
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          key: this.field.options_key,
          ...this.params,
          ...this.formdata,
          ...this.dependentdata
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      console.log(response.data)
      this.$parent.updateValue(this.field.key, response.data.value)
    }
  }
}
</script>
